import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { WoExternalComponent } from './working/wo-external/wo-external.component';

import { WoSystemComponent } from './working/wo-system/wo-system.component';

import { WoTechnologyComponent } from './working/wo-technology/wo-technology.component';
import { TeDomainDataComponent } from './working/wo-technology/te-domain-data/te-domain-data.component';
import { TeDomainExtComponent } from './working/wo-technology/te-domain-ext/te-domain-ext.component';
import { TeGeoCountryComponent } from './working/wo-technology/te-geo-country/te-geo-country.component';
import { TeRoleAuthComponent } from './working/wo-technology/te-role-auth/te-role-auth.component';
import { TeRoleDataComponent } from './working/wo-technology/te-role-data/te-role-data.component';
import { TeRoleFuncComponent } from './working/wo-technology/te-role-func/te-role-func.component';
import { TeRoleGroupComponent } from './working/wo-technology/te-role-group/te-role-group.component';
import { TeRolePermitComponent } from './working/wo-technology/te-role-permit/te-role-permit.component';
import { TeRoleTaskComponent } from './working/wo-technology/te-role-task/te-role-task.component';
import { TeUserDataComponent } from './working/wo-technology/te-user-data/te-user-data.component';
import { TeUserEmailComponent } from './working/wo-technology/te-user-email/te-user-email.component';
import { TeUserIpComponent } from './working/wo-technology/te-user-ip/te-user-ip.component';
import { ExLoginComponent } from './working/wo-external/ex-login/ex-login.component';
import { ExRecoverComponent } from './working/wo-external/ex-recover/ex-recover.component';
import { ExRegisterComponent } from './working/wo-external/ex-register/ex-register.component';
import { ExFooterComponent } from './graphic/gr-external/ex-footer/ex-footer.component';
import { ExNavbarComponent } from './graphic/gr-external/ex-navbar/ex-navbar.component';
import { InFooterComponent } from './graphic/gr-internal/in-footer/in-footer.component';
import { InNavbarComponent } from './graphic/gr-internal/in-navbar/in-navbar.component';

@NgModule({
  declarations: [
    AppComponent,

    WoExternalComponent,

    WoSystemComponent,

    WoTechnologyComponent,
    TeDomainDataComponent,
    TeDomainExtComponent,
    TeGeoCountryComponent,
    TeRoleAuthComponent,
    TeRoleDataComponent,
    TeRoleFuncComponent,
    TeRoleGroupComponent,
    TeRolePermitComponent,
    TeRoleTaskComponent,
    TeUserDataComponent,
    TeUserEmailComponent,
    TeUserIpComponent,
    ExLoginComponent,
    ExRecoverComponent,
    ExRegisterComponent,
    ExFooterComponent,
    ExNavbarComponent,
    InFooterComponent,
    InNavbarComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,

    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
